import { render, staticRenderFns } from "./PgaActivityItem.vue?vue&type=template&id=d911c44a&"
import script from "./PgaActivityItem.vue?vue&type=script&lang=ts&"
export * from "./PgaActivityItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d911c44a')) {
      api.createRecord('d911c44a', component.options)
    } else {
      api.reload('d911c44a', component.options)
    }
    module.hot.accept("./PgaActivityItem.vue?vue&type=template&id=d911c44a&", function () {
      api.rerender('d911c44a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Shared/Activity/Components/PgaActivityItem.vue"
export default component.exports